<template>
  <div class="personal-center">
    <header class="personal-center-header shadow">
      <div class="arrow-left" @click="goback">
        <img src="~@/assets/images/arrow_back.svg" />
      </div>
      <span>个人中心</span>
    </header>
    <section class="personal-center-section">
      <template v-if="type !== 'new_ls'">
        <base-block 
          des="头像"
          :rightInfo="rightTip"
          :canClick="canChangeClick"
          @click="handleReplace"
        >
          <img
            slot="rightInfo"
            class="avatar boy"
            :class="{ girl: userInfo.sex === 2 }"
            :src="userInfo.avatar || defaultPersonLogo"
          />
        </base-block>
        <base-block des="昵称" :rightInfo="rightTip"  :canClick="canChangeClick" @click="handleReplace">
          <div slot="rightInfo" style="margin-right:15px;">
            {{userInfo.nickname}}
          </div>
        </base-block>
      </template>
      <base-block
        des="真实姓名"
        :leftInfo="userInfo.realname"
        :rightInfo="userInfo.living_flag ? '' : '更换'"
        :canClick="userInfo.living_flag ? false : true"
        :isBreakWord="true"
        @click="changeName(userInfo)"
      />
      <base-block des="性别" :rightInfo="getSex" />
      <base-block
        :class="{ 'mb-10 shadow': type !== 'new_ls' }"
        des="用户ID"
        :rightInfo="userInfo.id"
        :setOnePxLine="type === 'new_ls' ? true : false"
      />
      <!-- 抖音登陆 -->
      <template v-if="allowThirdBind">
        <base-block des="第三方账号" :setOnePxLine="false" />
        <div class="item_content mb-10 shadow">
          <div class="wx_item" @click="goBindWx">
            <div class="wx_box">
              <div class="item_left">
                <base-icon icon="iconweixin1"></base-icon>
                <span class="ml-10">微信</span>
              </div>

              <div class="item_right" v-if="isNeedBindWeChat">
                <span class="n-title">未绑定</span>
                <img
                  class="arrow-right"
                  src="~@/assets/images/arrow_right.svg"
                />
              </div>
              <div class="item_right" v-else>
                <div class="avatar">
                  <img
                    slot="rightInfo"
                    class="avatar boy"
                    :class="{ girl: userInfo.sex === 2 }"
                    :src="userInfo.avatar"
                  />
                </div>
                <div>{{ userInfo.nickname }}</div>
              </div>
            </div>
          </div>

          <div
            class="wx_item"
            :class="{ canClickBox: !userInfo.dy_union_id }"
            @click="goBindDy"
          >
            <div class="wx_box">
              <div class="item_left">
                <base-icon icon="icondouyin"></base-icon>
                <span class="ml-10">抖音</span>
              </div>
              <div class="item_right" v-if="!userInfo.dy_union_id">
                <span class="n-title">未绑定</span>
                <img
                  class="arrow-right"
                  src="~@/assets/images/arrow_right.svg"
                />
              </div>
              <div class="item_right" v-else>
                <div class="avatar">
                  <img
                    slot="rightInfo"
                    class="avatar"
                    :src="userInfo.dy_avatar"
                  />
                </div>
                <div>{{ userInfo.dy_nickname }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 分割线 -->
      <base-block
        des="手机号绑定"
        :leftInfo="userInfo.phone"
        :rightInfo="'更换'"
        :canClick="true"
        @click="$refs.phoneInputWrap.open()"
      ></base-block>
      <base-block
        des="邮箱绑定"
        :leftInfo="userInfo.email"
        :rightInfo="userInfo.email ? '更换' : '未绑定'"
        :canClick="true"
        @click="openEmailInputWrap"
      ></base-block>
      <base-block
        des="密码管理"
        :rightInfo="'重置'"
        :canClick="canResetPassword"
        @click="openPwInputWrap"
      ></base-block>
      <base-block
        class="shadow"
        des="账号注销"
        :canClick="true"
        @click="handleLogoutAccount"
      ></base-block>
      <!-- 二维码功能暂时移除 -->
      <!-- <base-block class="mb-30 shadow" des="个人二维码" :setOnePxLine="false" :canClick="true" @click="$refs.qrcodeWrap.open(userInfo)">
          <img slot="rightInfo" class="qrcode" src="~@/assets/images/qrcode.svg" alt="二维码">
        </base-block> -->
    </section>
    <footer v-if="isBossOrProducerApp" class="personal-center-footer" @click="handleLogoutBossAndProducerApp">
        <button>退出登录</button>
      </footer>
    <div v-else class="logo-bottom">
      <img src="~@/assets/images/logo_bottom.svg" alt="" @click="goToSenguo" />
    </div>
    <!-- 弹窗组件 -->
    <phone-input-wrap ref="phoneInputWrap" @update-user-info="getUserInfo" />
    <email-input-wrap ref="emailInputWrap" @update-user-info="getUserInfo" />
    <replace-tip-wrap ref="replaceTipWrap" :isBind="!isNeedBindWeChat" />
    <pw-input-wrap ref="pwInputWrap" />
    <realname-input-wrap
      ref="realnameInputWrap"
      @update-user-info="getUserInfo"
    />

		<alinkPop ref="alinkPop" @confirm="onConfirm"/>
  </div>
</template>

<script>
import Axios from 'axios'
import domain from '@/config/systemDomain'
import mobileDomain from '@/config/moblieDomain'
import baseBlock from "./components/base-block";
import phoneInputWrap from "./components/phone-input-wrap";
import emailInputWrap from "./components/email-input-wrap";
import replaceTipWrap from './components/replace-tip-wrap.vue'
import pwInputWrap from "./components/pw-input-wrap";
import { whatApp, whatAppName, APP_NAME_ENUM } from "@/utils";
import { ORIGINAL_ID_OF_APPLET_ACCOUNT } from '@/config/config'
import realnameInputWrap from "./components/realname-input-wrap";
import alinkPop from './components/alink-pop.vue'
import JsBridge, { dyLogin, wechatLogin, androidPersistentCookie, launchMiniProgram, isAndroid } from "@/assets/js/js-bridge";

const cgFetch = Axios.create({
  baseURL: mobileDomain.cg
})

const CN_SPECIAL = 1
const GLOBAL_FLEX = 2

export default {
  data() {
    return {
      userInfo: {},
      wxAuthInfo: {
        wx_authorization_status: 0,
        wx_authorization_code: '',
        wx_openid: ''
      },
      type: "",
      appName: "",
      defaultPersonLogo: require('@/assets/images/icon_default_person.svg'),
    };
  },
  created() {
    this.getUserInfo();
    this.type = whatApp();
    this.appName = whatAppName()
  },

  computed: {
    getSex() {
      const sex = this.userInfo.sex;
      if (sex === 1) {
        return "男";
      } else if (sex === 2) {
        return "女";
      } else {
        return "";
      }
    },
    // 允许做第三方账号绑定
    allowThirdBind() {
      return ["new_ls", "pf"].includes(this.type);
    },
    // 是否需要绑定微信
    isNeedBindWeChat() {
      return !(this.userInfo.wx_unionid && this.userInfo.wx_unionid !== '(NULL)')
    },
    isBossOrProducerApp() {
      return this.appName === APP_NAME_ENUM.boss || this.appName === APP_NAME_ENUM.producer
    },
    authStrategy() {
      const otherInfo = this.getOtherInfo()
      const value = this.userInfo.auth_strategy !== undefined ? this.userInfo.auth_strategy : otherInfo.auth_strategy
      return Number(value) === GLOBAL_FLEX ? GLOBAL_FLEX : CN_SPECIAL
    },
    canUseEmailAbility() {
      return this.authStrategy === GLOBAL_FLEX
    },
    canResetPassword() {
      return !!this.userInfo.phone || (this.canUseEmailAbility && !!this.userInfo.email)
    },
    canChangeClick() {
      // 如果不来自app展示，来自app必须是批发易
      return !this.appName || [APP_NAME_ENUM.boss, APP_NAME_ENUM.bill, APP_NAME_ENUM.owner, APP_NAME_ENUM.producer].includes(this.appName)
    },
    rightTip() {
      if(this.canChangeClick) {
        return this.isNeedBindWeChat? '绑定微信' : '更新'
      }
      return ''
    }
  },
  methods: {
    getOtherInfo() {
      const { other_info: otherInfo } = this.userInfo
      if (!otherInfo) return {}
      if (typeof otherInfo === "string") {
        try {
          return JSON.parse(otherInfo)
        } catch (e) {
          return {}
        }
      }
      return otherInfo
    },
    handleLogoutAccount() {
      window.location.href = "https://i.senguo.cc/bbs/detail/8e5a7587ff932b84";
    },
    handleLogoutBossAndProducerApp() {
       this.$fetch
              .post({url: '/passport/logout'})
              .then(() => {
                androidPersistentCookie()
                const loginPath = this.appName === APP_NAME_ENUM.producer
                  ? '/mproducer/login'
                  : '/easy/login'
                window.location.replace(domain.pf_domain + loginPath)
              })
              .catch((e) => {
                this.openMessage(0, e.error_text || "登出失败")
              })
    },
    getUserInfo() {
      this.$fetch
        .get({
          url: "/user",
        })
        .then(
          (data) => {
            this.userInfo = data.user || {};
            this.getWxAuthInfo()
          },
          (e) => this.openMessage(0, e.error_text || "获取用户信息失败")
        );
    },
    openEmailInputWrap() {
      this.$refs.emailInputWrap.open(this.userInfo)
    },
    openPwInputWrap() {
      if (!this.canResetPassword) {
        return this.openMessage(0, "请先绑定手机号或邮箱")
      }
      this.$refs.pwInputWrap.open({
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        authStrategy: this.authStrategy
      })
    },
    getWxAuthInfo () {
      cgFetch.get('/api/user-center/payment-point/get', { withCredentials: true })
        .then((res) => {
          console.log(res)
          this.wxAuthInfo = res.data.data
        })
        .catch(() => {})
    },

    changeName(userInfo) {
      if (this.userInfo.living_flag) return;
      this.$refs.realnameInputWrap.open(userInfo);
    },

    goback() {
      this.$router.back();
    },

    goToSenguo() {
      window.open("https://www.senguo.cc");
    },
		// 绑定抖音
    async goBindDy() {
      if (!this.userInfo.dy_union_id) {
        if (this.type === "new_ls") {
          JsBridge.invokeMethod("getDouyinLoginCode", (code) => {
            const source = whatApp();
            // 清除code
            this.$fetch
              .post({
                url: "/login?method=bind_by_dy_code",
                params: {
                  code,
                  source: source ? source : undefined,
                },
              })
              .then((res) => {
                this.getUserInfo();
                if (res.error_text) {
                  this.openMessage(0, res.error_text);
                }
              })
              .catch((e) => {
                this.openMessage(0, e.error_text);
              });
          });
        } else if (this.type === "pf") {
          try {
            let dyRes = await dyLogin();
            const source = whatApp();
            // 清除code
            this.$fetch
              .post({
                url: "/login?method=bind_by_dy_code",
                params: {
                  code: dyRes[0],
                  source: source ? source : undefined,
                },
              })
              .then((res) => {
                this.getUserInfo();
                if (res.error_text) {
                  this.openMessage(0, res.error_text);
                }
              })
              .catch((e) => {
                  console.log(e)
                this.openMessage(0, e.error_text);
              });
          } catch (e) {
              console.log(e)
            this.openMessage(0, e.error_text || e || '绑定失败');
          }
        }
      }
    },
		/**
		 * 绑定微信: 增加了批发的账号合并环节(tower:https://tower.im/teams/175903/todos/133244/)
		 */
    async goBindWx() {
      if (this.type !== "pf") return
      if (!this.isNeedBindWeChat) return
      try {
        const wxCode = await wechatLogin();
        const res = await this.$fetch.post({
					url: `/user/bind/wx?source=pf&code=${encodeURIComponent(wxCode)}`,
					params: {
						is_check: this.type == "pf" ? true : false,
					}
				})
				if(res.phone_user && res.wx_user) {
					// 需要账号合并
					const data = {
						phone_user: res.phone_user,
						wx_user: res.wx_user
					}
					this.$refs.alinkPop.open(data)
				} else {
					// 不需要账号合并
					this.getUserInfo();
				}
      } catch (e) {
        this.openMessage(0, e.error_text || e.message || '绑定失败');
      }
    },
		// 账号合并
		onConfirm(data) {
			this.$fetch.post({
				url: "/user/passport/merge",
					params: {
						...data
					}
			}).then(() => {
				this.openMessage(1, "账号合并成功");
				this.getUserInfo();
			}).catch(e => {
				this.openMessage(0, e.error_text || "账号合并失败");
			})
		},

    // 更新用户头像昵称
    async handleReplace() {
        // appName 为空说明不是来自批发易,开票助手,货主帮,产地通
        if(this.type) {
            if(this.isNeedBindWeChat) {
              this.goBindWx()
              return
            }
            try {
              const wxCode = await wechatLogin();
              const res = await this.$fetch.post({
                url: `/head-img-url/update`,
                params: {
                  source: 'pf',
                  oa: this.appName === APP_NAME_ENUM.producer ? "oa_producer" : this.appName === APP_NAME_ENUM.owner ? 'oa_pf_supplier' : this.appName === APP_NAME_ENUM.bill ? 'oa_pf_kaipiao' : 'oa_pf_easy',
                  code: encodeURIComponent(wxCode)
                }
              })
              if(!res.changed) {
                this.$toast('微信信息获取存在延迟，如未更新请2小时后再试')
              }
              this.getUserInfo();
            } catch (e) {
              this.openMessage(0, e.error_text || e.message || '授权失败');
            }
        } else {
          this.$refs.replaceTipWrap.open()
        }
        
    }
  },
  components: {
    baseBlock,
    phoneInputWrap,
    emailInputWrap,
    replaceTipWrap,
    pwInputWrap,
    realnameInputWrap,
		alinkPop,
    // sexInputWrap
    // qrcodeWrap
  },
};
</script>

<style lang="scss" scoped>
.item_content {
  background-color: #fff;
}
.wx_item {
  // padding: 0 10px;
  padding: 0 10px;
  background-color: #fff;

  .wx_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
  }

  .item_left {
    display: flex;
    align-items: center;
  }

  .item_right {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;

    .avatar {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #ddd;
    }

    .n-title {
      font-size: 14px;
      color: #3c90ff;
      margin-right: 10px;
    }
    .arrow-right {
      display: block;
      width: 16px;
      height: 16px;
    }
  }
}

.canClickBox {
  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}

.mb-30 {
  margin-bottom: 30px;
}

.shadow {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.personal-center {
  max-width: 700px;
  height: 100%;
  margin: 0 auto;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  &-header {
    position: fixed;
    top: 0;
    width: 100%;
    max-width: 700px;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    text-align: center;
    background: #ffffff;
    z-index: 2;

    .arrow-left {
      position: absolute;
      left: 0;
      top: 50%;
      width: 40px;
      height: 100%;
      padding: 0 10px;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      img {
        width: 22px;
      }
    }

    span {
      font-weight: bolder;
    }
  }

  &-section {
    padding-top: 50px;

    .avatar {
      margin-right: 15px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    .qrcode {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  &-footer {
    margin-top: 10px;
    button {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 10px;
      text-align: center;
      font-size: 16px;
      color: #FF0000;
      letter-spacing: 0.24px;
      background: #fff;
      box-shadow: 0 1px 3px 0 #D4D4D4;

      &:hover {
        background: rgba(0, 0, 0, .05);
      }
    }
  }

  .logo-bottom {
    height: 40px;
    padding: 20px 0;
    box-sizing: content-box;
    text-align: center;

    img {
      height: 100%;
    }
  }
}
</style>
